"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.GetInfo = void 0;
var tslib_1 = require("tslib");
var fetch_1 = require("../../../library/fetch");
var certification_1 = require("../../model/certification");
var service_1 = require("../../../library/base/service");
var GetInfo = /** @class */ (function (_super) {
    (0, tslib_1.__extends)(GetInfo, _super);
    function GetInfo() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.name = '获取信息';
        _this.code = '101172';
        _this.desc = '获取信息';
        _this.requestParams = new certification_1.GetInfoRequest();
        _this.method = fetch_1.Methods.POST;
        return _this;
    }
    return GetInfo;
}(service_1.BaseService));
exports.GetInfo = GetInfo;
//# sourceMappingURL=getInfo.js.map